require('client/productDetail.js');
import Swiper, {Pagination, Navigation, A11y} from 'swiper';

const SWIPER_A11Y = {
    prevSlideMessage: 'Slide precedente',
    nextSlideMessage: 'Slide successiva',
    firstSlideMessage: 'Questa è la prima slide',
    lastSlideMessage: 'Questa è l’ultima slide',
    paginationBulletMessage: 'Vai alla slide {{index}}'
};

$(document).ready(() => {
    const anchorLink = $('.anchor-bar .nav-item .nav-link');

    anchorLink.on('click', function () {
        anchorLink.removeClass('active');
        $(this).addClass('active');
    });

    const requestPdfBtn = $('.js-request-pdf');
    const jsModalPdpBtn = $('.js-modal-pdp-button');
    const jsTooltipToggler = $('[data-toggle="tooltip"]');

    if (requestPdfBtn.length) {
        requestPdfBtn.on('click', function () {
            $.spinner().start();
            const ajaxUrl = $(this).data('href');
            if ((navigator.userAgent.indexOf("Safari") != -1 ||
                    navigator.userAgent.indexOf("Firefox") != -1) &&
                navigator.userAgent.indexOf("Chrome") < 0) {
                var newTab = openNewTab();
            }
            $.ajax({
                url: ajaxUrl,
                method: 'GET',
                success: function (data) {
                    if (navigator.userAgent.indexOf("Chrome") != -1 &&
                        navigator.userAgent.indexOf("Safari")) {
                        window.open(data.data.PDFUrl);
                        $.spinner().stop();
                    } else if (navigator.userAgent.indexOf("Safari") != -1 || navigator.userAgent.indexOf("Firefox") != -1) {
                        newTab.location.href = data.data.PDFUrl;
                        setTimeout(() => {
                            newTab.close();
                            $.spinner().stop();
                        }, 3000); // Waiting time to make sure the download has started
                    }
                },
                error: function () {
                    $.spinner().stop();
                    // TODO: need to show error message
                    alert('Error: View PDF');
                }
            });
        });
    }

    var dialogOpened = false;
    if (jsModalPdpBtn.length) {
        jsModalPdpBtn.on('click', function (e) {
            e.stopPropagation();

            if (!dialogOpened) {
                const ajaxPdpContentUrl = $(this).data('href');
                const target = $(this).data('target');
                const content = $(this).data('content');
                const day = $(this).data('day');
                const modalIndex = $(this).data('index');

                dialogOpened = true;
                const body = {
                    content: content,
                    day: day,
                    modalIndex: modalIndex
                };

                $.ajax({
                    url: ajaxPdpContentUrl,
                    method: 'POST',
                    contentType: "application/json",
                    data: JSON.stringify(body),
                    success: function (response) {
                        $('#infoModal .modal-dialog').append(response);
                        $(target).modal('show');

                        new Swiper('#modalSwiper', {
                            speed: 400,
                            spaceBetween: 100,
                            modules: [Pagination, Navigation, A11y],
                            a11y: SWIPER_A11Y,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'
                            },
                            slidesPerView: 1
                        });
                    },
                    error: function () {
                        alert('Error: Open Modal Denied');
                    }
                })

                $(target).on('hidden.bs.modal', function () {
                    dialogOpened = false;
                    $('#infoModal .modal-dialog').html('');
                })
            }
        });
    }

    jsTooltipToggler.each(function () {
        let toggler = $(this);
        let template = toggler.find('.tooltip').prop('outerHTML');

        toggler.tooltip({
            html: true,
            template: template,
            boundary: 'window'
        });
    });
});

$(window).on('load', function () {
    const socialIcons = $('.social-icons .sharethis-inline-share-buttons .st-btn');
    socialIcons.each(function () {
        $(this).addClass('icon icon-' + $(this).data('network'));
    });
});

function openNewTab() {
   var newTab = window.open('', '_blank');
   newTab.document.write('<html> \
   <head> \
   <style> \
   html, body { \
       height:100%; \
       width: 100%; \
       margin: 0; \
       padding: 0; \
       border: 0; \
       background-color: #ffffff; \
   } \
   .veil { \
       position: absolute; \
       z-index: 100; \
       text-align: center; \
       top: 0; \
       left: 0; \
       width: 100%; \
       height: 100%; \
       background-color: rgba(0, 0, 0, 0.5); \
   } \
   .spinner { \
      width: 80px; \
      height: 80px; \
      text-align: center; \
      animation: sk-rotate 2s infinite linear; \
      position: absolute; \
      top: 50%; \
      left: 50%; \
      margin-top: -40px; \
      margin-left: -40px; \
  } \
   .dot1, \
   .dot2 { \
       width: 60%; \
       height: 60%; \
       display: inline-block; \
       position: absolute; \
       top: 0; \
       background-color: #fff; \
       border-radius: 100%; \
       animation: sk-bounce 2s infinite ease-in-out; \
   } \
   .dot2 { \
       top: auto; \
       bottom: 0; \
       animation-delay: -1s; \
   } \
   @keyframes sk-rotate { \
       100% { transform: rotate(360deg); } \
   } \
   @keyframes sk-bounce { \
       0%, 100% { transform: scale(0); } \
       50% { transform: scale(1); } \
   } \
   </style> \
   </head> \
   <body> \
   <div class="veil"> \
       <div class="spinner"> \
           <div class="dot1"></div> \
           <div class="dot2"></div> \
       </div> \
   </div> \
   </body> \
   </html>');
   newTab.document.close();
   return newTab;
}
